import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconForward10Style0 = cosmosIconCss;

const CosmosIconForward10$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconForward10 extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'cc0861de4eb99acdf0130d1ee6847a2b5982ddd8', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5f43a33521ec408b57f2011fd4f72d06cc1d0479', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '898ce8708cac5ea332b3c0559f0796038dcba9d0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14 6.472H9.372a5.11 5.11 0 0 0-5.162 4.817 4.852 4.852 0 0 0 1.362 3.565 5 5 0 0 0 2.841 1.493.51.51 0 0 0 .587-.5v-.532a.51.51 0 0 0-.425-.493c-.73-.137-1.4-.49-1.926-1.015a3.323 3.323 0 0 1-.939-2.473 3.6 3.6 0 0 1 3.662-3.358H14v2.3a.5.5 0 0 0 .854.352l3.032-3.052a.5.5 0 0 0 0-.706l-3.033-3.024A.5.5 0 0 0 14 4.2v2.272Zm.149 10.478v-.621a.23.23 0 0 0-.239-.239h-.46v-2.87a.23.23 0 0 0-.24-.24h-.61a.851.851 0 0 0-.23.03l-1.05.33a.234.234 0 0 0-.16.29l.14.53a.235.235 0 0 0 .32.17l.64-.2v1.96h-.66a.23.23 0 0 0-.24.24v.62a.231.231 0 0 0 .24.24h2.309a.231.231 0 0 0 .24-.24Zm.451-1.25v-1.233a1.506 1.506 0 0 1 1.63-1.567 1.505 1.505 0 0 1 1.621 1.571V15.7a1.5 1.5 0 0 1-1.621 1.57 1.506 1.506 0 0 1-1.63-1.57Zm2.051-1.208v1.184l.004-.001c0 .349-.141.531-.429.531-.288 0-.431-.187-.431-.531v-1.183c0-.344.149-.532.431-.532.282 0 .425.182.425.532Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconForward10Style0; }
}, [1, "cosmos-icon-forward-10", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-forward-10"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-forward-10":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconForward10$1);
            }
            break;
    } });
}

const CosmosIconForward10 = CosmosIconForward10$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconForward10, defineCustomElement };
